import getProductData from './get-product-data';
import track from './track';

/**
 * Track whenever a product gets removed from the cart
 * @param {IProduct} product - the product model we want to track
 * @param {object} extraProps - additional tracking data
 */
export default function removeFromCart(product, extraProps) {
    return track({
        event: 'removeFromCart',
        ecommerce: {
            remove: {
                products: [getProductData(product, extraProps)],
            },
        },
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/remove-from-cart.js